import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import FloorplansServerComponent from "./components/floorplans/floorplanListing/floorplansServerComponent";
import "./styles/style.scss";
import Sightmap from "./components/sightmap/sightmap";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="find-your-home/floorplans" />} />
        <Route
          path="/find-your-home/floorplans"
          element={
            <Suspense key={new URLSearchParams(window.location.search)}>
              <FloorplansServerComponent typeListing={true} />
            </Suspense>
          }
        />
        <Route
          path="/find-your-home/floorplans/:floorplanName/:floorplanId"
          element={
            <Suspense key={new URLSearchParams(window.location.search)}>
              <FloorplansServerComponent typeListing={false} />
            </Suspense>
          }
        />
        <Route
          path="/find-your-home/sightmap"
          element={
            <Suspense key={new URLSearchParams(window.location.search)}>
              <Sightmap />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/find-your-home/floorplans" />} />
      </Routes>
    </Router>
  );
}

export default App;
